import { IconTile } from "@design";
import { LayoutDashboard } from "lucide-react";

// Micro-apps carry an icon name + color; a dynamic map lands with the picker.
export function MicroAppIcon() {
  return (
    <IconTile variant="neutral">
      <LayoutDashboard size={16} aria-hidden />
    </IconTile>
  );
}
